/**
 * ReminderQueueKpiCards - Cards de KPI totalizadores para fila de lembretes
 * Exibe métricas: Total, Pendentes, Enviados, Falhas, Visualizados
 * Segue padrão visual do QueueStatsCards
 * 
 * @version 1.0.0
 * RELEASE: 2026-03-29 v1.0.0 - Criação do componente
 */

import { Clock, Send, AlertCircle, Eye, Inbox } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import type { ReminderQueueStats } from '@/hooks/useReminderQueueStats';

interface ReminderQueueKpiCardsProps {
  stats: ReminderQueueStats;
  loading?: boolean;
}

export function ReminderQueueKpiCards({ stats, loading }: ReminderQueueKpiCardsProps) {
  const cards = [
    {
      title: 'Total',
      value: stats.total,
      icon: Inbox,
      color: 'text-foreground',
      bgColor: 'bg-muted',
    },
    {
      title: 'Pendentes',
      value: stats.pending,
      icon: Clock,
      color: 'text-yellow-600',
      bgColor: 'bg-yellow-500/10',
    },
    {
      title: 'Enviados',
      value: stats.sent,
      icon: Send,
      color: 'text-green-600',
      bgColor: 'bg-green-500/10',
    },
    {
      title: 'Falhas',
      value: stats.failed,
      icon: AlertCircle,
      color: 'text-destructive',
      bgColor: 'bg-destructive/10',
    },
    {
      title: 'Visualizados',
      value: stats.read_count,
      icon: Eye,
      color: 'text-blue-600',
      bgColor: 'bg-blue-500/10',
    },
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 px-6 py-3">
      {cards.map((card) => (
        <Card key={card.title} className="border-border/50 shadow-none">
          <CardContent className="p-3">
            <div className="flex items-center gap-2.5">
              {/* Ícone */}
              <div className={`p-1.5 rounded-lg ${card.bgColor}`}>
                <card.icon className={`h-4 w-4 ${card.color}`} />
              </div>
              {/* Conteúdo */}
              <div className="min-w-0">
                <p className="text-[10px] text-muted-foreground truncate">
                  {card.title}
                </p>
                {loading ? (
                  <div className="h-5 w-10 bg-muted animate-pulse rounded mt-0.5" />
                ) : (
                  <p className="text-lg font-bold leading-tight">{card.value}</p>
                )}
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
